// extracted by mini-css-extract-plugin
export default {"primary":"#044154"};